import { CFormTextarea, CModal, CModalBody, CModalFooter } from "@coreui/react";
import { useState } from "react";

export default function InternalCommentsModal({
  open,
  onClose,
  onUpdateInternalComments,
  initialInternalComments = "",
}: {
  open: boolean;
  onClose: () => void;
  onUpdateInternalComments: (comments: string) => Promise<void>;
  initialInternalComments: string;
}) {
  const [internalComments, setInternalComments] = useState(
    initialInternalComments,
  );
  return (
    <CModal alignment="center" visible={open} onClose={onClose}>
      <CModalBody className="p-3">
        <h5 className="fs-5 mb-4 border-bottom pb-1">Commentaires internes</h5>
        <CFormTextarea
          value={internalComments}
          onChange={(e: any) => setInternalComments(e.target.value)}
          className="custom-input"
          placeholder="Commentaires internes"
          rows={4}
        />
      </CModalBody>
      <CModalFooter className="p-3 d-flex justify-content-center gap-3">
        <button
          className="btn btn-danger text-white"
          onClick={() => onUpdateInternalComments(internalComments)}
        >
          Enregistrer
        </button>
        <button className="btn btn-secondary text-white" onClick={onClose}>
          Annuler
        </button>
      </CModalFooter>
    </CModal>
  );
}
